import { BlockTitle } from "@blocks/Blocks";
import Container from "@components/Container/Container";

/**
 * Component to render Judging Panel on SBA homepage
 */
const JudgingPanel = (): React.ReactElement => {
  return (
    <Container>
      <BlockTitle
        text="Judging Panel"
        rootClassName="text-center text-xl lg:mb-2 lg:text-8xl font-medium tracking-[1px]"
      />

      <div className="mb-11 w-full text-center lg:mb-14">
        <div className="flex flex-col py-3 pb-0 text-center font-public-sans leading-[1.4] text-gray-850 lg:flex-row lg:pb-3">
          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Mr Stephen Lee</strong>
              <br />
              Former Chairman, Singapore Airlines
              <br />
              (Chairman of the Judging Panel)
            </p>
          </div>

          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Ms Chen Huifen</strong>
              <br />
              Editor
              <br />
              The Business Times
            </p>
          </div>

          <div className="w-full p-3 pb-0 lg:w-1/3 lg:py-0">
            <p>
              <strong>Mr Christopher Ong</strong>
              <br />
              Senior Vice-President and Managing Director
              <br />
              DHL Express (Singapore) Pte Ltd
            </p>
          </div>
        </div>

        <div className="flex flex-col py-3 pb-0 text-center font-public-sans leading-[1.4] text-gray-850 lg:flex-row lg:pb-3">
          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Mr Jermaine Loy</strong>
              <br />
              Managing Director
              <br />
              Economic Development Board
            </p>
          </div>

          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Ms Jeannie Lim</strong>
              <br />
              {"Assistant Managing Director, Services & "}
              <br className="hidden lg:inline" />
              Growth Enterprises
              <br />
              Enterprise Singapore
            </p>
          </div>

          <div className="w-full p-3 pb-0 lg:w-1/3 lg:py-0">
            <p>
              <strong>Ms Jennie Chua</strong>
              <br />
              Chairman
              <br />
              Temasek Foundation
            </p>
          </div>
        </div>

        <div className="flex flex-col py-3 pb-0 text-center font-public-sans leading-[1.4] text-gray-850 lg:flex-row lg:pb-3">
          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Dr Kenneth Goh</strong>
              <br />
              {"Associate professor of Strategy & "}
              <br className="hidden lg:inline" />
              Entrepreneurship
              <br />
              Lee Kong Chian School of Business
              <br />
              Singapore Management University
            </p>
          </div>

          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Mr Lim Ming Yan</strong>
              <br />
              Chairman
              <br />
              Changi Airport Group
            </p>
          </div>

          <div className="w-full p-3 pb-0 lg:w-1/3 lg:py-0">
            <p>
              <strong>Mr Loh Boon Chye</strong>
              <br />
              Chief Executive Officer
              <br />
              SGX Group
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-center py-3 text-center font-public-sans leading-[1.4] text-gray-850 lg:flex-row">
          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Professor Wee Chow Hou</strong>
              <br />
              Emeritus Professor, Nanyang Technological
              <br />
              University;
              <br />
              Honorary Fellow, Singapore University of Social
              <br />
              Sciences
            </p>
          </div>

          <div className="w-full p-3 lg:w-1/3 lg:py-0">
            <p>
              <strong>Mr Wong Wei Kong</strong>
              <br />
              Editor-In-Chief, EMTM Group
              <br />
              SPH Media Limited
            </p>
          </div>

          <div className="w-full p-3 pb-0 lg:w-1/3 lg:py-0">
            <p>
              <strong>Mr Yung Chiun Ooi</strong>
              <br />
              Senior Director, Projects
              <br />
              DHL Express Asia Pacific
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default JudgingPanel;
